function pad(str = "", number, ch = " ") {
  return (new Array((number || 1) + 1).join(ch) + str).slice(-(number || 2));
}

export default pad;
